import { http, HttpResponse } from 'msw';

const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL;

export const handlers = [
  // CSRFトークン取得
  http.get(`${baseUrl}/token`, (_) => {
    return new HttpResponse(null, { status: 200 });
    // Refused to set unsafe header "cookie" のエラーが出るためcookieを作成しないようにコメントアウト
    // (既にブラウザにセッション情報があり)エラーが出るのが気になる場合は、シークレットブラウザで開くか、セッション情報(cookieや各種ストレージ)を削除してください
    // return new HttpResponse(null, {
    //   headers: {
    //     'Set-Cookie': '_user_csrf_cloud=dummy-csrf-token',
    //   },
    // });
  }),
  // サインイン
  http.post(`${baseUrl}/sign_in`, async ({ request }) => {
    const { email, password, remember_me, individual } =
      (await request.json()) as Required<{
        email: string;
        password: string;
        remember_me: boolean;
        individual?: boolean;
      }>;
    console.table({
      email: email,
      password: password,
      remember_me: remember_me,
      individual: individual,
    });

    if (email === 'sample@example.com' && password === 'password') {
      return HttpResponse.json({ success: true });
    } else if (email === 'error@dummy.com') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'email',
              message: 'メールアドレスを正しい書式で入力してください。',
            },
          ],
        },
        { status: 400 }
      );
    } else if (password === 'errorpass') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [{ field: 'password', message: 'パスワードエラー。' }],
        },
        { status: 400 }
      );
    } else {
      return HttpResponse.json(
        { message: 'メールアドレスまたはパスワードが違います' },
        { status: 401 }
      );
    }
  }),
  // リフレッシュ
  http.post(`${baseUrl}/sign_in/refresh`, async () => {
    return HttpResponse.json({ success: true });
  }),
  // Google サインイン URL
  http.get(`${baseUrl}/sign_in/sso/oidc/google`, (_) => {
    return HttpResponse.json({
      sign_in_url: 'https://dummy-google-sign-in-url.com',
    });
  }),
  // サインアウト
  http.post(`${baseUrl}/sign_out`, (_) => {
    return HttpResponse.json({ success: true });
  }),
];
